import HashManager from 'assets/core/js/module/hash-manager'
import { PartialsEvents } from 'assets/core/js/module/partials-manager'
import { getQueryParameters } from 'assets/core/js/page/product/search'
import { setFiltersFromHash } from 'assets/core/js/page/product/search/filters'
import type { Facets } from 'assets/core/js/page/product/search/facets'
import type { AccommodationsData, AccommodationsOrder } from 'assets/core/js/types/globals'

export default function (facets: Facets): void {
  const resultsEl = document.querySelector('[data-partial-id="results"]')

  if (resultsEl) {
    resultsEl.addEventListener(PartialsEvents.POST_UPDATE, (e: Event) => {
      void (async () => {
        const detail = (e as CustomEvent).detail as {
          data: {
            accommodationsData: AccommodationsData
            accommodationsOrder: AccommodationsOrder
          }
        }

        if (detail?.data) {
          window.accommodationsData = detail.data.accommodationsData
          window.accommodationsOrder = detail.data.accommodationsOrder
        }
        await setFiltersFromHash(facets)
      })()
    })
  }
}

export const updatePartials = function (): void {
  const queryParameters = getQueryParameters()

  const hashParameters = { ...HashManager.getParameters(), ...queryParameters }

  if (queryParameters.checkInDate === '') {
    delete queryParameters.checkInDate
    delete hashParameters.checkInDate
  }

  if (queryParameters.night === '') {
    delete queryParameters.night
    delete hashParameters.night
  }

  HashManager.setParameters(hashParameters, true)
}
